export const PHONE = /^[\\+]{0,1}[0-9]{8,10}$/;

export const DEBIT_CARD = /^5439[0-9]{12}$/;

export const CLABE = /^6461801460[0-9]{8}|6461802042[0-9]{8}|721180[0-9]{12}$/;

export const CLABE_SPEI = /^721180[0-9]{12}$/;

export const CUSTOMER_NUMBER = /^2426-(11|10)-[0-9]{10}$/;

export const ACCOUNT = /^(10|11|12|13)[1-9]{2}[0-9]{12}$/;

export const SPEI_OUT_AUTH  = /^[0-9]{3}ALBO(19|20)\\d\\d(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(0[0-9]|1[0-9]|2[0-3])[0-5][0-9]$/;

export const REGEX_TAXID = /(^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})$)/;
export const REGEX_PHONE = /(^\+(?:[0-9] ?){6,14}[0-9]$)/;
export const REGEX_BIN = /^6461802042[0-9]{8}|721[0-9]{15}$/;
export const REGEX_BINS = /^(543924\d{10},?)+$/;
export const REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const REGEX_NUMBER = /^\d+$/;
export const REGEX_ACCOUNT = /^[0-9]{10,14}$/;
export const REGEX_UUID = /^[0-9a-f]{21}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export const REGEX_TEXT = /^[a-zA-Z0-9_-]+$/;

export const isValid = (search: string): boolean => {

  if (validateRegEx(search, PHONE)) { return true; }
  if (validateRegEx(search, REGEX_EMAIL)) { return true; }
  if (validateRegEx(search, DEBIT_CARD)) { return true; }
  if (validateRegEx(search, CLABE)) { return true; }
  if (validateRegEx(search, CLABE_SPEI)) { return true; }
  if (validateRegEx(search, CUSTOMER_NUMBER)) { return true; }
  if (validateRegEx(search, ACCOUNT)) { return true; }
  if (validateRegEx(search, SPEI_OUT_AUTH)) { return true; }
  if (validateRegEx(search, REGEX_UUID)) { return true; }

  return false;
}

const validateRegEx = (search: string, regex: RegExp): boolean => {
  var  serchfind: boolean;

  const regexp = new RegExp(regex);
  serchfind = regexp.test(search);

  return serchfind
}